function RentalPortalApplicantProfileHeaderContent() {
  return null
}

export default RentalPortalApplicantProfileHeaderContent
